import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const ContactSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.15 });
  const items = [
    { icon:Phone, label:'Telephone', value:'+1 (800) 123-4567', href:'tel:+18001234567' },
    { icon:Mail, label:'Email', value:'info@trademarksymbolfont.com', href:'mailto:info@trademarksymbolfont.com' },
    { icon:MapPin, label:'Office', value:'3031 Tisch Way 110 PW, San Jose, CA 95128', href:null },
    { icon:Clock, label:'Business Hours', value:'Monday–Friday, 9AM–6PM PST', href:null },
  ];
  return (
    <section data-testid="contact-section" ref={section.ref} className="py-16 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`grid lg:grid-cols-12 gap-12 scroll-fade-up ${section.isVisible?'scroll-visible':''}`}>
          <div className="lg:col-span-5">
            <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-3 block font-semibold">Contact</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] mb-4" style={{fontFamily:"'Playfair Display',serif"}}>Speak With<br />Our Team.</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed mb-6">Whether you have a preliminary question or are ready to proceed with filing, our team responds within 24 hours.</p>
            <button data-testid="contact-form-trigger" onClick={onOpenContactForm} className="text-[#6366F1] font-medium text-sm hover:text-[#1E1B4B] transition-colors ">Open the consultation form</button>
          </div>
          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {items.map((item,i)=>{const Wrapper=item.href?'a':'div';const props=item.href?{href:item.href}:{};return(
                <Wrapper key={i} {...props} data-testid={`contact-item-${i}`} className="group border border-[#E2E2F0] bg-[#F5F3FF] p-6 hover-soft cursor-default">
                  <div className="w-9 h-9 border border-[#E2E2F0] bg-white flex items-center justify-center mb-3 hover-soft">
                    <item.icon className="w-4 h-4 text-[#6366F1]" strokeWidth={1.5} />
                  </div>
                  <span className="text-[10px] text-[#4B5563] uppercase tracking-[0.15em] font-semibold block mb-1">{item.label}</span>
                  <span className="text-sm text-[#1E1B4B] font-medium">{item.value}</span>
                </Wrapper>
              );})}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ContactSection;
